import { tv } from "tailwind-variants";

export const divider = tv({
    base: ["tw:border-b tw:border-b-divider"],

    variants: {
        marginTop: {
            "0": "tw:mt-0",
            "1": "tw:mt-1",
            "2": "tw:mt-2",
            "3": "tw:mt-3",
            "4": "tw:mt-4",
            "5": "tw:mt-5"
        }
    },
    defaultVariants: {
        marginTop: "3"
    }
});
